<template>
  <div class="purchase-detail-box">
    <v-title
      title="添加拜访"
      :isShowBack="true"
      :isDefaultBack="false"
      @backHandle="goBack()"
    >
    </v-title>
    <div class="purchase-header" v-show="loading === false">
      <cube-form
          :model="clientModel"
          @validate="clientValidateHandler"
        >
          <cube-form-group >
            <cube-form-item v-for="(item, index) in clientInfoField" :key="item.modelKey" :field="clientInfoField[index]"></cube-form-item>
            <span class="areaTitle">所在地区</span>
            <v-area
              ref="areaPicker"
              class="area fr"
              :defaultAreaName="defaultAreaName"
              @areaChange="areaPickerHandle"
              @cancel="pushUserLog('地区选择-取消')"
              @pickerClick="pushUserLog('地区选择')"
            ></v-area>
          </cube-form-group>
        </cube-form>
    </div>
    <div class="purchase-main">
      <div class="navBar">
        <cube-scroll-nav-bar
          :current="current"
          :labels="labels"
          :txts="txts"
          @change="handleClick"
          class="scrollNav"
        />
      </div>
      <div ref="customerProduct" v-show="current === '产品信息1'" class="fillForm">
        <div class="purchase-main-list">
          <cube-form
            :model="productModel"
            @validate="proValidateHandler"
          >
            <cube-form-group >
              <cube-form-item v-for="(item, index) in productField" :key="item.label" :field="productField[index]"></cube-form-item>
            </cube-form-group>
          </cube-form>
        </div>
      </div>
       <div ref="customerProduct" v-show="current === '产品信息2'" class="fillForm">
        <div class="purchase-main-list">
          <cube-form
            :model="competitiveProductModel"
            @validate="comValidateHandler"
          >
            <cube-form-group >
              <cube-form-item v-for="(item, index) in competitiveProductField" :key="item.modelKey" :field="competitiveProductField[index]"></cube-form-item>
            </cube-form-group>
          </cube-form>
        </div>
      </div>
      <div ref="else" v-show="current === '其他信息'" class="fillForm">
        <div class="">
          <cube-form
            :model="otherInfoModel"
            @validate="othValidateHandler"
          >
            <cube-form-group>
              <cube-form-item :field="field[0]"></cube-form-item>
              <cube-form-item :field="field[1]"></cube-form-item>
              <cube-form-item :field="field[2]"></cube-form-item>
            </cube-form-group>
          </cube-form>
        </div>
      </div>
      <v-map
        ref="vMap"
        @positionAreaName="positionAreaHandle"
      >
      </v-map>
      <button
        type="button"
        :disabled="buttonEnable"
        v-show="isOriginHei"
        class="btn-item navigation"
        @click="handleSubmit"
      >
        提交拜访
      </button>
    </div>
    <custom-loading v-if="loading" :isMask="true"></custom-loading>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import VArea from '@/components/AreaPicker.vue'
import VArea from '@/components/clientAreaPicker.vue'
import { getProductList, getCompetitiveProductList, addOrCommitVisit } from '@/api/clientVisit'
import VMap from '@/components/VMap.vue'
import CustomLoading from '@/components/CustomLoading.vue'
export default {
  name: 'addVisit',
  components: {
    VArea,
    VMap,
    CustomLoading
  },
  computed: {
    ...mapGetters(['provinceList', 'cityList', 'districtList']),
    provinceOptions () {
      const options = []
      this.provinceList.forEach((item) => {
        options.push({
          text: item.name,
          value: item.name
        })
      })
      return options
    },
    refName () {
      if (this.current === '产品信息1') {
        return 'customerProduct'
      } else if (this.current === '产品信息2') {
        return 'rivalProduct'
      } else {
        return 'else'
      }
    }
  },
  watch: {
    screenHeight () {
      if (this.originHeight > this.screenHeight) {
        this.isOriginHei = false
      } else {
        this.isOriginHei = true
      }
    }
  },
  created () {
    this.getVisitProductList()
  },
  mounted () {
    const self = this
    const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
    window.onresize = function() {
      return (function() {
        self.screenHeight = document.documentElement.clientHeight
        const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
        if (resizeHeight - 0 < originalHeight - 0) {
          // 当软键盘弹起，在此处操作
          document.querySelector('body').setAttribute('style', 'height:' + originalHeight + 'px;')
          this.scrollerHeight = resizeHeight
        } else {
          // 当软键盘收起，在此处操作
          document.querySelector('body').setAttribute('style', 'height:100%;')
          this.scrollerHeight = '100%'
        }
      })()
    }
  },
  data () {
    return {
      buttonEnable: false,
      defaultAreaName: {},
      clientModel: {},
      provinceList: [],
      productModel: {},
      otherInfoModel: {},
      competitiveProductModel: {},
      isOriginHei: true,
      screenHeight: document.documentElement.clientHeight,
      originHeight: document.documentElement.clientHeight,
      clientInfoField: [
        {
          type: 'input',
          modelKey: 'clientName',
          label: '终端名称',
          props: {
            placeholder: '请输入终端名称'
          },
          rules: {
            required: true,
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            max: 30,
            min: 1,
            message: '请输入1-30个字符！'
          },
          messages: {
            pattern: '请输入1-30个汉字、大小写英文或数字'
          }
        },
        {
          type: 'cube-select',
          modelKey: 'clientType',
          model: 'select',
          label: '终端类型',
          props: {
            placeholder: '请选择终端类型',
            options: [
              {
                text: '单体药店',
                value: '单体药店'
              },
              {
                text: '连锁门店',
                value: '连锁门店'
              },
              {
                text: '连锁总部',
                value: '连锁总部'
              },
              {
                text: '诊所',
                value: '诊所'
              }
            ]
          }
        }
      ],
      productField: [],
      competitiveProductField: [],
      field: [
        {
          type: 'input',
          modelKey: 'contacts',
          label: '联系人',
          props: {
            placeholder: '请输入联系人'
          },
          rules: {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            max: 10,
            min: 1,
            message: '请输入1-10个字符！'
          },
          messages: {
            pattern: '请输入1-10个汉字大小写英文或数字'
          }
        },
        {
          type: 'input',
          modelKey: 'contactsNumber',
          label: '电话',
          props: {
            placeholder: '请输入电话'
          },
          rules: {
            pattern: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/
          },
          messages: {
            pattern: '请输入正确的电话号码'
          }
        },
        {
          type: 'textarea',
          modelKey: 'remark',
          label: '备注',
          props: {
            placeholder: '请输入备注',
            maxlength: 30
          },
          rules: {
            max: 30
          }
        }],
      current: '产品信息1',
      labels: ['产品信息1', '产品信息2', '其他信息'],
      txts: ['产品信息1', '产品信息2', '其他信息'],
      loading: false,
      areaInfo: {},
      keyword: '',
      detailData: '',
      searchData: '',
      clientValid: undefined,
      productValid: undefined,
      competitiveValid: undefined,
      otherInfoValid: undefined
    }
  },

  filters: {
  },
  methods: {
    positionAreaHandle (area) {
      if (area.provinceName === '北京市') {
        area.cityName = '北京城区'
      }
      if (area.provinceName === '上海市') {
        area.cityName = '上海城区'
      }
      if (area.provinceName === '天津市') {
        area.cityName = '天津城区'
      }
      if (area.provinceName === '重庆市') {
        area.cityName = '重庆城区'
      }
      this.defaultAreaName = area
      this.areaInfo.provinceName = area.provinceName
      this.areaInfo.cityName = area.cityName
      this.areaInfo.districtName = area.districtName
      this.areaInfo.provinceCode = 'D' + area.provinceCode
      this.areaInfo.cityCode = 'D' + area.cityCode
      this.areaInfo.districtCode = 'D' + area.districtCode
      this.getClientCompetitiveProductList('D' + area.cityCode)
    },
    areaPickerHandle (areaObj) {
      this.areaInfo = areaObj
      this.competitiveProductField = []
      this.getClientCompetitiveProductList(areaObj.cityCode)
    },
    clientValidateHandler(result) {
      this.clientValid = result.valid
    },
    proValidateHandler(result) {
      this.productValid = result.valid
    },
    comValidateHandler(result) {
      this.competitiveValid = result.valid
    },
    othValidateHandler(result) {
      this.otherInfoValid = result.valid
    },
    getVisitProductList () {
      getProductList().then((res) => {
        const products = res.data
        for (let i = 0; i < products.length; i++) {
          this.productField.push({
            type: 'input',
            modelKey: products[i],
            label: products[i],
            props: {
              placeholder: '请输入拜访价'
            },
            rules: {
              message: { pattern: '只允许输入数字，支持输入5位整数和小数点后2位' },
              pattern: /^(^0\.\d{0,1}[0-9]$)|(^[1-9]\d{0,4}\.\d{1,2}$)|(^[1-9]\d{0,4})$/
            },
            messages: {
              pattern: '只允许输入数字，支持输入5位整数和小数点后2位'
            }
          })
        }
      })
    },
    getClientCompetitiveProductList (cityCode) {
      getCompetitiveProductList(cityCode).then(({ code, message, data = null }) => {
        if (code === 1) {
          const competitiveProducts = data
          for (let i = 0; i < competitiveProducts.length; i++) {
            this.competitiveProductField.push({
              type: 'input',
              modelKey: competitiveProducts[i],
              label: competitiveProducts[i],
              props: {
                placeholder: '请输入拜访价'
              },
              rules: {
                message: { pattern: '只允许输入数字，支持输入5位整数和小数点后2位' },
                pattern: /^(^0\.\d{0,1}[0-9]$)|(^[1-9]\d{0,4}\.\d{1,2}$)|(^[1-9]\d{0,4})$/
              },
              messages: {
                pattern: '只允许输入数字，支持输入5位整数和小数点后2位'
              }
            })
          }
        } else {
          throw new Error(message)
        }
      }).catch((error) => {
        console.log('123', error)
      })
    },
    handleSubmit () {
      this.buttonEnable = true
      console.log(3434, this.clientModel)
      const { provinceCode, provinceName, cityCode, cityName, districtCode, districtName } = this.areaInfo
      const querys = { ...this.clientModel }
      querys.provinceCode = provinceCode
      querys.provinceName = provinceName
      querys.cityCode = cityCode
      querys.cityName = cityName
      querys.districtCode = districtCode
      querys.districtName = districtName
      querys.clientInfo = this.otherInfoModel
      querys.matchClientId = null
      querys.address = null
      querys.chainBrand = null
      querys.phone = null
      const productList = []
      const competitiveProduct = []
      for (const key in this.productModel) {
        if (this.productModel[key] !== '') {
          const temp = {}
          temp.productName = key
          temp.price = this.productModel[key]
          productList.push(temp)
        }
      }
      for (const key in this.competitiveProductModel) {
        if (this.competitiveProductModel[key] !== '') {
          const temp = {}
          temp.productName = key
          temp.price = this.competitiveProductModel[key]
          competitiveProduct.push(temp)
        }
      }
      querys.productList = productList
      querys.competitiveProduct = competitiveProduct
      console.log(555, querys)
      if (!querys.clientName) {
        this.$createDialog({
          title: '提示',
          type: 'alert',
          content: '请填写终端信息！'
        }).show()
        this.buttonEnable = false
      } else if (this.clientValid === false || this.productValid === false || this.competitiveValid === false || this.otherInfoValid === false) {
        this.$createDialog({
          title: '提示',
          type: 'alert',
          content: '请检查填写信息！'
        }).show()
        this.buttonEnable = false
      } else {
        this.toastsub = this.$createToast({
          txt: '正在提交。。。',
          time: 0,
          mask: false
        }).show()
        addOrCommitVisit(querys).then((res) => {
          if (res.code === 1) {
            this.toastsub.hide()
            this.$router.push({ name: 'visitSuccess', query: { data: res.data } })
          } else {
            throw new Error(res.message)
          }
        }).finally(
          this.buttonEnable = false,
          this.toastsub.hide()
        )
      }
    },
    handleClick (cur) {
      this.current = cur
    },
    goBack () {
      // this.$router.push({name:'index'})
      this.$router.back()
    },
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/base/base.styl';
/deep/ .cube-picker-wheel-wrapper{
  flex-wrap: wrap;
}
/deep/ .cube-scroll-nav-bar-item{
  padding: 25px 60px
}
/deep/ .cube-form_standard .cube-textarea-wrapper.cube-textarea_expanded {
  height: 160px
  padding-bottom: 10px
}
.fillForm {
    height: 600px
    overflow: scroll
  }
.purchase-detail-box {
  height: 100%;
  background: #efefef;
}

.purchase-header {
  padding 32px
  padding-top 100px
  background: #fff
  .areaTitle{
    margin-top: 20px
    margin-left: 26px
    font-size 31px
  }
  /deep/ .area-li{
    font-size: 25px
  }
  /deep/ .sprite{
    display: none
  }
  /deep/ .cube-select-icon{
    display: none
  }
  .area {
    margin-top: 25px
    width: 500px
  }
}

.purchase-main {
  padding-bottom: 50px
  .btn-item{
    position: fixed
    bottom: 0px
    left: 0
    right: 0
    display:block
    margin:30px auto
    width 654px
    height 88px
    border-radius: 8px
    &.navigation{
      text-align: center
      font-size $font-XXXL
      color $color-white
      background $color-main
    }
  }
  .navBar {
    margin-top: 20px;
    margin-bottom: 5px
  }
  .purchase-main-list {
    background: #fff;
    /deep/ .cube-form_standard .cube-form-label {
      width: 500px
      padding: 15px 25px 15px 0
    }
    .purchase-main-list-item {
      width: 686px;
      margin: 0 auto;
    }

    .purchase-main-list-item {
      border-bottom: 2px solid #efefef;
      padding-bottom: 36px;
      padding-top: 26px;
      color: #666;
      line-height: 1;
      font-size: 26px;

      .price-box {
        text-align: end;
        .count {
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
<style scoped>

</style>
